import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RevisionProvider } from '../../revision-system/context/RevisionContext';
import { generalConfig } from '../config/general-config';
import Dashboard from '../../revision-system/components/Dashboard';
import SectionManager from '../../revision-system/components/SectionManager';
import CardList from '../../revision-system/components/CardList';
import RevisionSession from '../../revision-system/components/RevisionSession';
import MigrationTool from '../../revision-system/components/MigrationTool';

/**
 * GeneralApp - Wrapper component for the General Revision System
 * 
 * This component wraps the shared revision system components with General-specific
 * configuration, including:
 * - General-specific Firestore collections (general-sections, general-cards, general-reviews)
 * - General-specific routing (/general-revision/*)
 * - Greek Input component disabled (not needed for general content)
 * - Migration filter for sections NOT starting with "Greek " (all non-Greek sections)
 * 
 * Requirements: 1.2, 9.1-9.7
 */
export const GeneralApp: React.FC = () => {
  return (
    <RevisionProvider config={generalConfig}>
      <Routes>
        {/* Dashboard - Main landing page */}
        <Route path="/" element={<Dashboard />} />
        
        {/* Section Management */}
        <Route path="/sections" element={<SectionManager />} />
        <Route path="/sections/:sectionId" element={<SectionManager />} />
        
        {/* Review Session - All due cards */}
        <Route path="/session" element={<RevisionSession />} />
        
        {/* Review Session - Specific section */}
        <Route path="/session/:sectionId" element={<RevisionSession />} />
        
        {/* Migration Tool */}
        <Route path="/migration" element={<MigrationTool config={generalConfig} />} />
        
        {/* Catch-all redirect to dashboard */}
        <Route path="*" element={<Navigate to="/general-revision/" replace />} />
      </Routes>
    </RevisionProvider>
  );
};

export default GeneralApp;
